import { render, staticRenderFns } from "./ReviewMailings.vue?vue&type=template&id=aad8702c&scoped=true&"
import script from "./ReviewMailings.vue?vue&type=script&lang=ts&"
export * from "./ReviewMailings.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewMailings.vue?vue&type=style&index=0&id=aad8702c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad8702c",
  null
  
)

export default component.exports